var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2835 0C17.3615 1.64617 18.4467 3.36336 19.5402 5.15152C20.6124 4.32818 21.3724 3.25492 21.82 1.93181C22.0368 3.64901 22.2544 5.36614 22.4713 7.08333C26.5037 4.31027 27.0463 4.95421 24.0996 9.01515C25.317 9.73869 26.6196 10.2753 28.0076 10.625C26.7754 11.2518 25.4726 11.6811 24.0996 11.9129C26.0569 12.988 27.4678 14.3832 28.3333 16.0985C26.7746 14.8964 25.1463 14.4671 23.4483 14.8107C24.8598 16.3111 25.9455 18.0283 26.705 19.9621C26.378 20.6196 25.9442 20.7269 25.4023 20.2841C24.6715 18.9165 23.6945 17.736 22.4713 16.7424C22.6309 19.52 22.6309 22.3105 22.4713 25.1136C21.3855 22.3232 20.3004 19.5328 19.2146 16.7424C17.4774 20.606 15.7409 24.4697 14.0039 28.3333C14.3543 24.2414 14.7887 20.1632 15.3065 16.0985C-0.459846 25.1981 -1.21931 24.2323 13.0268 13.2007C8.62571 12.7062 4.28387 11.9549 0 10.947C4.11061 10.314 8.23556 9.77744 12.3755 9.33712C0.881264 3.09986 1.31506 2.34857 13.6782 7.08333C13.895 6.97599 14.1126 6.86871 14.3295 6.76136C7.26767 -0.700799 7.919 -1.2374 16.2835 5.15152C16.3982 3.61527 16.3982 1.89807 16.2835 0Z",
    fill: "#40B0BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.9172ae1cc7af1c59003ef98d669ca06e.svg";
export { ForwardRef as ReactComponent };